module.exports = {
  pending: "pending",
  success: "success",
  failed: "failed",
};
